import React from "react";
import { getYouTubeVideoId, convertStarsToHtml } from "../utils/helpers";

const ReelPlayerModal = ({ reel, onClose, lang }) => {
  if (!reel) return null;
  const videoId = getYouTubeVideoId(reel.shortVideo);
  if (!videoId) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-lg overflow-hidden w-full max-w-4xl flex flex-col md:flex-row max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-black text-3xl z-20 leading-none"
        >
          &times;
        </button>
        {/* Left side: Video Player */}
        <div className="w-full md:w-1/3 flex-shrink-0 bg-black">
          <div className="aspect-[9/16] w-full">
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=0`}
              title={reel.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        {/* Right side: Title and Content */}
        <div className="w-full md:w-2/3 p-6 overflow-y-auto overflow-x-hidden">
          <h2
            className="text-2xl font-bold mb-3 break-words"
            style={{ overflowWrap: "anywhere" }}
          >
            {reel.title}
          </h2>
          <div
            className="text-gray-700 whitespace-pre-wrap break-words"
            style={{ overflowWrap: "anywhere" }}
            dangerouslySetInnerHTML={{
              __html: (function () {
                const raw = reel.content || "";
                if (/<[^>]+>/g.test(raw)) return raw;
                return convertStarsToHtml(raw);
              })(),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ReelPlayerModal;
